import { z } from "zod";

const optionalMoney = z.coerce
  .number()
  .positive()
  .optional()
  .or(z.literal("" as unknown as number));

export const freightSchema = z.object({
  companyId: z.string().min(1, "Empresa obrigatória"),
  driverId: z.string().optional().or(z.literal("")),
  vehicleId: z.string().optional().or(z.literal("")),
  originCity: z.string().min(1, "Cidade de origem obrigatória").max(100),
  originState: z.string().length(2, "UF deve ter 2 letras"),
  destinationCity: z.string().min(1, "Cidade de destino obrigatória").max(100),
  destinationState: z.string().length(2, "UF deve ter 2 letras"),
  cargoDescription: z
    .string()
    .min(1, "Descrição da carga obrigatória")
    .max(300),
  cargoWeight: optionalMoney,
  cargoType: z.string().max(100).optional(),
  cteNumber: z.string().max(50).optional(),
  deliveryNfeNumber: z.string().max(50).optional(),
  freightValue: z.coerce
    .number({ error: "Valor inválido" })
    .positive("Valor do frete deve ser positivo")
    .optional()
    .or(z.literal("" as unknown as number)),
  driverValue: optionalMoney,
  advancePercent: z.coerce
    .number()
    .min(0)
    .max(100)
    .optional()
    .or(z.literal("" as unknown as number)),
  notes: z.string().max(500).optional(),
});

export type FreightFormData = z.infer<typeof freightSchema>;
